/**
 * Opal’s presentations functionality offers several slide types.
 *
 * * `Day`, `Week`, and `Month` are a snapshot of the corresponding calendar
 *   view.
 * * `Moment` is a snapshot of a given moment.
 * * `Canvas` provides customizable text and/or image slides.
 */
export const enum SlideType {
  /**
   * Day view, previously called ‘day by day’ or ‘run of show’. Uses Storyfirst
   * data.
   *
   * @see `Timescale.Day`
   */
  Day = 'run_of_show',
  /**
   * Uses Storyfirst data.
   *
   * @see `Timescale.Week`
   */
  Week = 'week_view',
  /**
   * Uses Storyfirst data.
   *
   * @see `Timescale.Month`
   */
  Month = 'month_view',

  /**
   * Generic slides that don’t use Storyfirst data.
   */
  Canvas = 'canvas',

  /**
   * Storyfirst data for a single moment.
   */
  Moment = 'single_moment',

  /**
   * @deprecated Replaced by `Canvas` around 2018.
   */
  Text = 'text',
}
